const formValueChanged = 'form-value-changed'
const submittingForm = 'submitting-form'

export {
    formValueChanged,
    submittingForm,
}